module.exports = __webpack_public_path__ + "static/media/referralPlanBG.23749170.png";